require('../../modules/es6.array.find');
module.exports = require('../../modules/_core').Array.find;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/array/find.js
// module id = 1057
// module chunks = 0